import { NotificacionServiceEmisor } from "@shared/services";
import { PayloadError } from "../PayloadError";
import { ITransportador } from "../Transportador";
import { LogTipos } from "../Utilidades";
import { MensajeProcesador } from "./mensajesProduccionProcesadores";

export const MensajeProduccionTransportadorFactory = (notificacionService: NotificacionServiceEmisor,
    listaMensajesProcesador: MensajeProcesador[]) =>
    new MensajeProduccionTransportador(notificacionService, listaMensajesProcesador);

export class MensajeProduccionTransportador implements ITransportador {
    constructor(private notificacionService: NotificacionServiceEmisor,
        private mensajesProcesador: MensajeProcesador[]) {}

    escribir(payload: PayloadError, _tipo: LogTipos) {
        this.mensajesProcesador.forEach(mensajeProcesador => {
            if (mensajeProcesador.puedeProcesar(payload.mensaje)) {
                const mensaje = mensajeProcesador.procesar(payload.mensaje) ?? "";
                this.notificacionService.notificarError(mensaje, true);
            }
        });
    }
}
